export default {
  layout: {
    navPos: 'left', // top, bottom, left, right, false
    toolbar: 'top', // top, bottom, false
    footer: true, // above, below, false
    boxed: false, // true, false
    roundedCorners: false, // true, false
    viewAnimation: 'fade-top' // fade-left, fade-right, fade-top, fade-top-in-out, fade-bottom, fade-bottom-in-out, fade, false
  },
  valueAccountNumber: '',
  AccountNumbers: [],
  splashScreen: true,
  logged: true,
  accountTypeObj: '',
  transferAccountInfos: [],
  selectLang: '',
  logoutDialog: false,
  source: '',
  tradeAccountList: [],
  // orderId: '',
  tradeAccountRecords: [],
  applyTradeRecords: [],
  accountInfo: '',
  allAccountInfo: '',
  userInfo: '',
  clientProfile: '',
  rejectRecords: {},
  idToken: '',
  accessToken: localStorage.getItem('access_token') ? localStorage.getItem('access_token') : '',
  accountOpeningAgreement: true,
  setBullionConfig: false,
  accountBalance: [],
  subBankAccounts: [],
  isAccountOpening: false,
  filterSPTradingAccountList: [] // 过滤掉了sp的交易账户
}
